import React, { useEffect, useState } from 'react';
import './CollapsibleComponent.scss';
import { NotificationFlag } from '../NotificationFlag/NotificationFlag';

interface CollapsibleComponentProps {
    isExpanded?: boolean;
    defaultExpanded?: boolean;
    className?: string;
    headerClassName?: string;
    contentClassName?: string;
    onToggle?: (isExpanded: boolean) => void;
    children: React.ReactNode;
    header: React.ReactNode;
    notificationFlag?: string;
    validationError?: boolean;
}

const CollapsibleComponent = (props: CollapsibleComponentProps) => {
    const [expanded, setExpanded] = useState(props.defaultExpanded);

    useEffect(() => {
        if (props.isExpanded !== undefined && props.isExpanded !== null) {
            setExpanded(props.isExpanded);
        }
    }, [props.isExpanded]);

    const toggle = () => {
        const newExpandedState = !expanded;
        setExpanded(newExpandedState);
        if (props.onToggle) {
            props.onToggle(newExpandedState);
        }
    };

    return (
        <div className={`collapsible-component ${props.className ?? ''}`}>
            <div
                className={`collapsible-header ${props.headerClassName ?? ''}`}
                onClick={toggle}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        toggle();
                    }
                }}>
                <span className="header-wrapper">
                    {props.header}{' '}
                    {props.validationError ? (
                        <div
                            className={
                                !!props.validationError ? 'error-section' : ''
                            }
                        />
                    ) : (
                        []
                    )}
                    {props.notificationFlag ? (
                        <NotificationFlag
                            eventCode={props.notificationFlag}
                            includePrefix={true}
                        />
                    ) : (
                        []
                    )}
                </span>
                <span
                    className={`collapsible-icon ${
                        expanded ? 'expanded' : ''
                    }`}>
                    {expanded ? '-' : '+'}
                </span>
            </div>
            {expanded && (
                <div
                    className={`collapsible-content ${props.contentClassName}`}>
                    {props.children}
                </div>
            )}
        </div>
    );
};

export default CollapsibleComponent;
